<template>
    <div v-wechat-title="title" v-if="surgeryId && surgeryId > 0" :style="{ 'min-height': `${this.screenHeight - 220}px` }">
        <el-footer style="position: absolute; bottom: 0; background: white; width: 100%; z-index: 99; margin-left: -10px; height: 100px !important">
            <CusStep :steps="transportNode">
                <div slot-scope="{ step }">
                    <span v-if="!step.report_url">{{ step.content }}</span>
                    <span v-else><el-link :href="step.report_url" target="_blank" type="primary" class="el-icon-link">{{ step.content }}</el-link></span>
                </div>
            </CusStep>
        </el-footer>
        <el-row>
            <el-col :span="6" class="padding5"><item-input type="scan" v-model="scan_val" @input="scanCode" :autofocus="true"></item-input></el-col>
            <el-button title="同步病理检查申请单" type="primary" size="mini" @click.stop="syncSpecimenApplication" class="align-right" style="float: right; margin-top: 1em; margin-right: 2em"
                ><span class="el-icon-refresh"></span>&nbsp;同步申请单</el-button
            >
            <el-button type="primary" size="mini" @click.stop="printBatchBar" class="align-right" style="float: right; margin-top: 1em; margin-right: 2em"
                ><span class="el-icon-printer"></span>&nbsp;批量打印条码</el-button
            >
            <el-button type="primary" size="mini" @click="loadTemplatesView" v-if="this.permissions && this.permissions.findIndex(item => item.permission === `specimen:load_template`) != -1" class="align-right" style="float: right; margin-top: 1em; margin-right: 2em"
                >批量添加</el-button
            >
        </el-row>
        <el-row class="margin-bottom100">
            <el-col :md="12" :lg="6" class="padding5 align-left">
                <div class="specimen specimen-new" @click="loadAddSpecimenView()">
                    <span class="el-icon-plus"></span>
                    添加标本
                </div>
            </el-col>
            <el-col :md="12" :lg="6" v-for="specimen in specimens" :key="specimen.id" class="padding5 align-left">
                <el-card class="specimen" :class="{ active: activeSpecimenId == specimen.id }" :body-style="{ padding: '5px' }">
                    <div @click.stop="loadTransportNode(specimen.id)">
                        <el-row class="align-center padding5">
                            <el-col :span="12" class="font-size20"
                                ><el-checkbox style="float: left" @change="checked => SelectedSpecimen(checked, specimen.identification_code)"></el-checkbox>
                                <span :title="specimen.name" style="display: inline-block; white-space: nowrap; text-overflow: ellipsis; overflow: hidden; width: 90%">{{
                                    specimen.name
                                }}</span></el-col
                            >
                            <el-col :span="12" class="align-right" v-if="!specimen.enum_specimen_deliver_location">
                                <span class="fg-primary cus-button" @click.stop="printDocument(specimen)"><font-awesome-icon :icon="['fas', 'print']" title="打印送检单"></font-awesome-icon></span>
                                <span class="fg-primary cus-button" @click.stop="printOneBar(specimen)"><font-awesome-icon :icon="['fas', 'barcode']" title="打印条形码"></font-awesome-icon></span>
                                <span class="fg-primary cus-button" @click.stop="loadUpdateView(specimen)"><font-awesome-icon :icon="['fas', 'edit']"></font-awesome-icon></span>
                                <span class="el-icon-delete fg-danger cus-button" @click.stop="deleteSpecimen(specimen)"></span>
                            </el-col>
                            <el-col :span="12" class="align-right" v-else>
                                <span class="fg-primary cus-button" @click.stop="printDocument(specimen)"><font-awesome-icon :icon="['fas', 'print']" title="打印送检单"></font-awesome-icon></span>
                                <span class="fg-primary cus-button" @click.stop="printOneBar(specimen)"><font-awesome-icon :icon="['fas', 'barcode']" title="打印条形码"></font-awesome-icon></span>
                            </el-col>
                        </el-row>
                        <div class="padding10 content">
                            <div>
                                取材部位：{{ specimen.sampling_position }}
                                <el-tag type="danger" size="mini" v-if="specimen.is_frozen_section">冰冻切片</el-tag>
                            </div>
                            <div>标本号：{{ specimen.identification_code }}</div>
                            <div>项目名称：{{ specimen.application_name }}</div>
                            <div>申请时间：<text-formatter type="datetime" v-model="specimen.application_date"></text-formatter></div>
                            <div>数量：{{ specimen.quantity }}</div>
                            <div>组织离体时间：<text-formatter type="datetime" v-model="specimen.tissue_in_vitro_date"></text-formatter></div>
                            <div>组织固定时间：<text-formatter type="datetime" v-model="specimen.tissue_fixation_date"></text-formatter></div>
                            <div>送检日期：<text-formatter type="datetime" v-model="specimen.deliver_date"></text-formatter></div>
                            <div>创建人：{{ specimen.creator }}</div>
                        </div>
                        <div class="align-right" style="display: flex; align-items: center; justify-content: flex-end; height: 40px">
                            <span v-if="specimen.enum_specimen_deliver_location">{{ specimen.specimen_deliver_location }}</span>
                            <el-button v-else type="primary" plain size="mini" @click="loadSpecimenCheckedView(specimen)">核对并转出</el-button>
                        </div>
                    </div>
                </el-card>
            </el-col>
        </el-row>
        <form-dialog :title="specimenView.title" :visible.sync="specimenView.dialogFormVisible" :data="specimenView.data" :columns="columnList" width="40%" @confirm="saveSpecimen"></form-dialog>
        <form-dialog
            title="核对并转出"
            :visible.sync="specimenCheckView.dialogFormVisible"
            :data="specimenCheckView.data"
            :columns="specimenCheckViewColums"
            width="40%"
            @confirm="specimenChecked"
        ></form-dialog>
        <div style="height: 0; overflow: hidden">
            <table id="print-content" style="font-size: 20px; text-align: left">
                <tr>
                    <td colspan="3" style="text-align: center; font-size: 30px">病理标本袋</td>
                </tr>
                <tr>
                    <td width="200px" style="position: relative">
                        姓名
                        <div style="display: inline; border-bottom: 1px solid; width: 100px; position: absolute; bottom: 0"></div>
                        <div style="position: absolute; left: 50px; top: 0; font-size: 16px">{{ primary_item.patient_name }}</div>
                    </td>
                    <td width="180px" style="position: relative">
                        性别
                        <div style="display: inline; border-bottom: 1px solid; width: 100px; position: absolute; bottom: 0"></div>
                        <div style="position: absolute; left: 50px; top: 0; font-size: 16px">{{ primary_item.sex }}</div>
                    </td>
                    <td width="160px" style="position: relative">
                        年龄
                        <div style="display: inline; border-bottom: 1px solid; width: 100px; position: absolute; bottom: 0"></div>
                        <div style="position: absolute; left: 50px; top: 0; font-size: 16px">{{ primary_item.age }}</div>
                    </td>
                </tr>
                <tr>
                    <td style="position: relative">
                        {{ T(`specimen.visit_no`) }}
                        <div style="display: inline; border-bottom: 1px solid; width: 100px; position: absolute; bottom: 0"></div>
                        <div style="position: absolute; left: 70px; top: 0; font-size: 16px">{{ primary_item.visit_no }}</div>
                    </td>
                    <td style="position: relative">
                        科室
                        <div style="display: inline; border-bottom: 1px solid; width: 100px; position: absolute; bottom: 0"></div>
                        <div style="position: absolute; left: 50px; top: 0; font-size: 16px">{{ primary_item.dic_section }}</div>
                    </td>
                    <td style="position: relative">
                        床号
                        <div style="display: inline; border-bottom: 1px solid; width: 100px; position: absolute; bottom: 0"></div>
                        <div style="position: absolute; left: 50px; top: 0; font-size: 16px">{{ primary_item.bed_no }}</div>
                    </td>
                </tr>
                <tr>
                    <td colspan="3" style="position: relative">
                        标本名称
                        <div style="display: inline; border-bottom: 1px solid; width: 448px; position: absolute; bottom: 0"></div>
                        <div style="position: absolute; left: 100px; top: 0; font-size: 16px">{{ primary_item.name }}</div>
                    </td>
                </tr>
                <tr>
                    <td style="position: relative">
                        数量
                        <div style="display: inline; border-bottom: 1px solid; width: 100px; position: absolute; bottom: 0"></div>
                        <div style="position: absolute; left: 50px; top: 0; font-size: 16px">{{ primary_item.quantity }}</div>
                    </td>
                    <td colspan="2" style="position: relative">
                        病理号
                        <div style="display: inline; border-bottom: 1px solid; width: 265px; position: absolute; bottom: 0"></div>
                        <div style="position: absolute; left: 100px; top: 0; font-size: 16px">{{ primary_item.application_number }}</div>
                    </td>
                </tr>
                <tr>
                    <td colspan="3" style="position: relative">
                        组织离体时间
                        <div style="display: inline; border-bottom: 1px solid; width: 410px; position: absolute; bottom: 0"></div>
                        <div style="position: absolute; left: 200px; top: 0; font-size: 16px">{{ primary_item.tissue_in_vitro_date }}</div>
                    </td>
                </tr>
                <tr>
                    <td colspan="3" style="position: relative">
                        组织固定时间
                        <div style="display: inline; border-bottom: 1px solid; width: 410px; position: absolute; bottom: 0"></div>
                        <div style="position: absolute; left: 200px; top: 0; font-size: 16px">{{ primary_item.tissue_fixation_date }}</div>
                    </td>
                </tr>
                <tr>
                    <td colspan="3" style="position: relative">
                        送检日期
                        <div style="display: inline; border-bottom: 1px solid; width: 450px; position: absolute; bottom: 0"></div>
                        <div style="position: absolute; left: 200px; top: 0; font-size: 16px">{{ primary_item.deliver_date }}</div>
                    </td>
                </tr>
                <tr>
                    <td colspan="3"><img style="width: 100%" :src="primary_item.bar_code" /></td>
                </tr>
            </table>
        </div>
        <cus-dialog class="table-h560" title="提取模板" :visible.sync="specimenTmp.dialogFormVisible" :close-on-click-modal="false" width="90%" @confirm="addTemplateToList">
            <div class="padding20 align-left">
                <el-row>
                    <span class="line-height35">请选模板:</span>
                    <item-input
                         type="groupselect"
                        :collapseTags="false"
                        v-model="specimenTmp.selected_template"
                        :options="specimenTmp.specimen_template"
                        :clearable="true"
                        style="display: inline-block; width: 300px"
                    ></item-input>
                    <span style="padding-left: 20px;color: red;">注：申请单号必填，未填写情况下不进行标本数据读取！</span>
                </el-row>
            </div>

                <!-- :selectAll="true"
                :selection="true" -->
            <list-view
                ref="specimenTmplist"
                :columns="specimenTmpcolumnList"
                :datalist="specimenTmp.datalist"
                @extrabutton-click="ExtraButtonClick"
                :showSequence="false"
            ></list-view>
        </cus-dialog>
    </div>
    <p v-else class="no-surgery">暂无手术</p>
</template>
<script>
import { mapGetters } from 'vuex'
import printJs from 'print-js'
export default {
    name: `Specimen`,
    props: {

    },
    data() {
        return {
            title: `病理标本`,
            surgeryId: this.$route.query.surgery_id,
            activeSpecimenId: undefined,
            specimens: [],
            scan_val: ``,
            primary_item: {},
            application_numbers: [],
            specimenNames: [],
            specimenView: {
                dialogFormVisible: false,
                data: {}
            },
            transportNode: [],
            specimenCheckView: {
                dialogFormVisible: false,
                enum_specimen_deliver_location: 1,
                data: {}
            },
            SpecimenTypes: [], // 标本类型
            SpecimensSelected: [], // 已选择的标本
            specimenNameConfig: this.$root.SpecimenNameConfig,
            specimenTmp: {
                dialogFormVisible: false,
                selected_template: undefined,
                specimen_template: [],
                datalist: []
            }
        }
    },
    mounted() {
        this.loadSpecimens()
        this.loadSpecimenNames()
        this.loadSpecimenTypes()
    },
    computed: {
        ...mapGetters([`permissions`, `ward_auth`, `sys_enums`, `currentUser`, `screenHeight`, `currentSurgery`]),
        specimenCheckViewColums() {
            return [{
                type: `p`,
                prop: `p1`,
                colspan: 24
            }, {
                type: `select`,
                prop: `enum_specimen_deliver_location`,
                label: `转往目的地`,
                colspan: 24,
                default: this.specimenCheckView.enum_specimen_deliver_location,
                options: this.sys_enums && this.sys_enums.SpecimenDeliverLocation || [],
                validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
            }, {
                type: `string`,
                prop: `deliverer`,
                label: `送检人员`,
                colspan: 24,
                default: this.currentUser && this.currentUser.dic_worker_name,
                validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
            }, {
                type: `datetime`,
                prop: `deliver_date`,
                label: `送检时间`,
                colspan: 24,
                default: this.$moment().format(`YYYY/MM/DD HH:mm:ss`),
                validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
            }]
        },
        columnList() {
            let self = this
            let r = []
            if (self.specimenNameConfig == `1` || self.specimenNameConfig == `2`) {
                r.push({
                    type: `select`,
                    prop: `name`,
                    label: `标本名称`,
                    colspan: 24,
                    config: {
                        allowCreate: self.specimenNameConfig == `2`
                    },
                    options: this.specimenNames,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                })
            } else {
                r.push({
                    type: `string`,
                    prop: `name`,
                    label: `标本名称`,
                    colspan: 24,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                })
            }
            r = r.concat([{
                type: `string`,
                prop: `sampling_position`,
                label: `取材部位`,
                colspan: 12
            }, {
                type: `number`,
                prop: `quantity`,
                label: `标本数量`,
                colspan: 12,
                default: 1,
                validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
            }, {
                type: `datetime`,
                prop: `tissue_in_vitro_date`,
                label: `离体时间`,
                colspan: 12,
                default: this.$moment().format(`YYYY/MM/DD HH:mm:ss`),
                validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
            }, {
                type: `datetime`,
                prop: `tissue_fixation_date`,
                label: `固定时间`,
                colspan: 12
            }, {
                type: `checkbox`,
                prop: `is_frozen_section`,
                label: `冰冻切片`,
                colspan: 24,
                default: false
            },
            {
                type: `string`,
                prop: `application_name`,
                label: `病理检查项目名称`,
                colspan: 12
            },
            {
                type: `datetime`,
                prop: `application_date`,
                label: `申请时间`,
                colspan: 12
            },
            {
                type: `select`,
                prop: `dic_specimentype_id`,
                label: `标本类型`,
                isListable: true,
                isExpand: false,
                isEditable: true,
                isCreatable: true,
                colspan: 12,
                options: this.SpecimenTypes,
                validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
            },
            {
                type: `multiselect`,
                prop: `infectious`,
                label: `传染病`,
                isListable: true,
                isExpand: false,
                isEditable: true,
                isCreatable: true,
                colspan: 12,
                options: (that, { row }) => {
                    let data = this.sys_enums.Enum_Infectious || []
                    var ret = data.map(d => {
                        d.value = d.label
                        return d
                    })
                    return ret
                },
                validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
            },
            {
                type: `checkbox`,
                prop: `is_soak_section`,
                label: `是否浸泡`,
                colspan: 12,
                default: false,
                change: (that, { row, index }) => {
                    if (!row.is_soak_section) {
                        row.soak_water = ``
                    }
                }
            },
            {
                type: `select`,
                prop: `soak_water`,
                label: `浸泡液`,
                isListable: true,
                isExpand: false,
                isEditable: true,
                isCreatable: true,
                colspan: 12,
                options: (that, { row }) => {
                    let data = this.sys_enums.Enum_SoakWater || []
                    var ret = data.map(d => {
                        d.value = d.label
                        return d
                    })
                    return ret
                },
                readonly: function(that, { row, column, area }) {
                    if (area == `form`) {
                        return !row.is_soak_section
                    } else {
                        return true
                    }
                }
            }
            ])
            if (this.application_numbers.length > 0) {
                r.splice(-6, 0, {
                    type: `select`,
                    prop: `application_number`,
                    label: `申请单号`,
                    colspan: 24,
                    config: {
                        allowCreate: true
                    },
                    options: this.application_numbers,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }],
                    change: (that, { row, index }) => {
                        if (self.application_numbers) {
                            let application = _.filter(self.application_numbers, d => {
                                return d.value == row.application_number
                            })
                            if (application && application[0] && application[0].code) {
                                let code = application[0].code.split(` | `)
                                row.application_name = code[0]
                                row.application_date = code[1]
                            }
                        }
                    }
                })
            } else {
                r.splice(-6, 0, {
                    type: `string`,
                    prop: `application_number`,
                    label: `申请单号`,
                    colspan: 24,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                })
            }
            return r
        },
        specimenTmpcolumnList() {
            let self = this
            return [
                {
                    type: `string`,
                    prop: `id`,
                    label: `编号`,
                    width: `80`,
                    isKey: true
                },
                {
                    type: `select`,
                    prop: `application_number`,
                    width: `120`,
                    label: `申请单号`,
                    config: {
                        allowCreate: true
                    },
                    options: this.application_numbers,
                    change: (that, { row, index }) => {
                        if (self.application_numbers) {
                            let application = _.filter(self.application_numbers, d => {
                                return d.value == row.application_number
                            })
                            if (application && application[0] && application[0].code) {
                                let code = application[0].code.split(` | `)
                                row.application_name = code[0]
                                row.application_date = code[1]
                            }
                        }
                    },
                    readonly: false,
                    isListable: this.application_numbers.length > 0
                },
                {
                    type: `string`,
                    prop: `application_number`,
                    width: `120`,
                    label: `申请单号`,
                    readonly: false,
                    isListable: !this.application_numbers.length
                },
                {
                    type: `string`,
                    prop: `application_name`,
                    label: `病理检查项目名称`,
                    width: `130`,
                    readonly: false,
                    isListable: true
                },
                {
                    type: `datetime`,
                    prop: `application_date`,
                    width: `160`,
                    label: `申请时间`,
                    readonly: false,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `specimen_name`,
                    label: `标本名称`,
                    readonly: false,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `sampling_position`,
                    label: `取材部位`,
                    width: `80`,
                    readonly: false,
                    isListable: true
                }, {
                    type: `number`,
                    prop: `quantity`,
                    label: `标本数量`,
                    width: `80`,
                    readonly: false,
                    isListable: true
                },
                {
                    type: `datetime`,
                    prop: `tissue_in_vitro_date`,
                    label: `离体时间`,
                    readonly: false,
                    width: `160`,
                    isListable: true
                }, {
                    type: `datetime`,
                    prop: `tissue_fixation_date`,
                    label: `固定时间`,
                    width: `160`,
                    readonly: false,
                    isListable: true
                },
                {
                    type: `bool`,
                    prop: `is_frozen_section`,
                    label: `冰冻切片`,
                    options: `enum_bool`,
                    width: `80`,
                    readonly: false,
                    isListable: true
                },
                {
                    type: `select`,
                    prop: `dic_specimen_type_id`,
                    label: `标本类型`,
                    width: `100`,
                    readonly: false,
                    options: this.SpecimenTypes,
                    isListable: true
                },
                {
                    type: `multiselect`,
                    prop: `infectious`,
                    label: `传染病`,
                    options: (that, { row }) => {
                        let data = this.sys_enums.Enum_Infectious || []
                        var ret = data.map(d => {
                            d.value = d.label
                            return d
                        })
                        return ret
                    },
                    width: `100`,
                    readonly: false,
                    isListable: true
                },
                {
                    type: `bool`,
                    prop: `is_soak_section`,
                    label: `是否浸泡`,
                    options: `enum_bool`,
                    width: `80`,
                    readonly: false,
                    change: (that, { row, index }) => {
                        if (!row.is_soak_section) {
                            row.soak_water = ``
                        }
                    },
                    isListable: true
                },
                {
                    type: `select`,
                    prop: `soak_water`,
                    label: `浸泡液`,
                    width: `100`,
                    isListable: true,
                    options: (that, { row }) => {
                        let data = this.sys_enums.Enum_SoakWater || []
                        var ret = data.map(d => {
                            d.value = d.label
                            return d
                        })
                        return ret
                    },
                    readonly: function(that, { row, column, area }) {
                        return !row.is_soak_section
                    }
                }
            ]
        }
    },
    methods: {
        ExtraButtonClick(target) {
            if (this[target.emit]) {
                this[target.emit](target)
            } else {
                this.$emit(target.emit, target)
            }
        },
        selectionChange({ row }) {
            console.log(row)
            this.checkedRow = row
            console.log(`checkedRow`, this.checkedRow)
        },
        SaveAsTemplate() { },
        loadTemplatesView() {
            // 加载可选模板，弹出模板选择框
            this.specimenTmp.selected_template = undefined
            this.specimenTmp.datalist = []
            let that = this
            return new Promise((resolve, reject) => {
                let req = that.myaxios.get(`/api/Nursing/SpecimenTemplate/Get`)
                req.then(data => {
                    data = _.filter(data, d => {
                        let allRegionValue = []
                        _.map(that.ward_auth, d => {
                            allRegionValue.push(d.value)
                        })
                        let owids = (d.dic_operating_ward_id && d.dic_operating_ward_id != `` && d.dic_operating_ward_id.split(`,`)) || []
                        let hasow =
                                _.filter(owids, c => {
                                    return _.includes(allRegionValue, `ow_${c}`)
                                }) || []
                        let rwids = (d.dic_recovery_ward_id && d.dic_recovery_ward_id != `` && d.dic_recovery_ward_id.split(`,`)) || []
                        let hasrw =
                                _.filter(rwids, c => {
                                    return _.includes(allRegionValue, `rw_${c}`)
                                }) || []
                        return (d.region_type == 2 && (hasow.length > 0 || hasrw.length > 0)) || (d.region_type == 1 && d.owner == this.currentUser.username)
                    })
                    let groupId = _.groupBy(data, `id`)
                    let ts = _.reduce(
                        groupId,
                        function(result, g, key) {
                            let region = g.map(s => {
                                let ows =
                                    s.dic_operating_ward_id &&
                                    s.dic_operating_ward_id.split(`,`).map(item => {
                                        let data = _.find(that.ward_auth, { value: `ow_${item}` })
                                        return data && data.label
                                    })
                                let rws =
                                    s.dic_recovery_ward_id &&
                                    s.dic_recovery_ward_id.split(`,`).map(item => {
                                        let data = _.find(that.ward_auth, { value: `rw_${item}` })
                                        return data && data.label
                                    })
                                let ow =
                                    ows &&
                                    _.join(
                                        ows.filter(t => t),
                                        `,`
                                    )
                                let rw =
                                    rws &&
                                    _.join(
                                        rws.filter(t => t),
                                        `,`
                                    )
                                return ow || rw || that.currentUser.dic_worker_name
                            })
                            let r = {
                                label: g[0].name,
                                value: g[0].id,
                                jianpin: g[0].abbr,
                                code: region.join(`|`),
                                group: _.includes(region, that.currentUser.dic_worker_name) ? `个人模板` : `区域模板`
                            }
                            result.push(r)
                            return result
                        },
                        []
                    )
                    this.specimenTmp.specimen_template = _.orderBy(ts, `group`)
                    this.specimenTmp.dialogFormVisible = true
                    resolve(data)
                }).catch(e => reject(e))
            })
        },
        addTemplateToList() {
            let selectedTempItems = this.specimenTmp.datalist && _.filter(this.specimenTmp.datalist, d => d.application_number)
            if (!selectedTempItems || selectedTempItems.length == 0) {
                this.$message.warning(`未选择标本`)
                return
            }
            try {
                selectedTempItems.forEach(d => {
                    if (!d.application_number) {
                        this.$message.error(`请录入申请单号！`)
                        throw new Error(`EndIterative`)
                    }
                    if (!d.specimen_name) {
                        this.$message.error(`请录入标本名称！`)
                        throw new Error(`EndIterative`)
                    }
                    if (!d.quantity) {
                        this.$message.error(`请录入标本数量！`)
                        throw new Error(`EndIterative`)
                    }
                    if (!d.tissue_in_vitro_date) {
                        this.$message.error(`请录入离体时间！`)
                        throw new Error(`EndIterative`)
                    }
                    if (!d.dic_specimen_type_id) {
                        this.$message.error(`请选择标本类型！`)
                        throw new Error(`EndIterative`)
                    }
                    if (!d.infectious) {
                        this.$message.error(`请选择传染病！`)
                        throw new Error(`EndIterative`)
                    }
                    d.id = 0
                    d.name = d.specimen_name
                    d.dic_specimentype_id = d.dic_specimen_type_id
                    d.infectious = d.infectious && d.infectious.join(`,`)
                    d.biz_surgery_info_id = this.surgeryId
                    let tissueInVitroDate = this.$moment(d.tissue_in_vitro_date)
                    let tissueFixationDate = this.$moment(d.tissue_fixation_date)
                    if (this.$moment.duration(tissueInVitroDate.diff(tissueFixationDate))._milliseconds > 0) {
                        this.$message.warning(`固定时间不能早于离体时间`)
                        throw new Error(`EndIterative`)
                    }
                })
            } catch (e) {
                if (e.message != `EndIterative`) throw e
                return
            }

            console.log(`selectedTempItems`, selectedTempItems)
            let req = this.myaxios.post(`/api/Nursing/Specimen/PostMany`, selectedTempItems)
            req.then(data => {
                this.specimenTmp.datalist = []
                this.specimenTmp.dialogFormVisible = false
                this.loadSpecimens()
            }).catch(e => {
                console.log(e)
            })
        },
        loadSpecimenNames() {
            if (!this.surgeryId) { return }
            let req = this.myaxios.get(`api/Nursing/DicSpecimen/GetSpecimenNames`)
            req.then(data => {
                this.specimenNames = data
            }).catch(e => {
                console.log(e)
                this.specimenNames = []
            })
        },
        loadApplicationNumbers() {
            return this.myaxios.get(`api/Nursing/Specimen/ApplicationNumbers?surgeryInfoId=${this.surgeryId}`)
        },
        loadAddSpecimenView(number) {
            this.loadApplicationNumbers().then((numbers) => {
                this.application_numbers = _.map(numbers, d => {
                    d.value = `${d.value}`
                    d.label = `${d.value}`
                    d.color = `#606266`
                    return d
                })
                this.specimenView.title = `创建`
                this.specimenView.data = {
                    application_number: number || ``,
                    tissue_in_vitro_date: _.last(this.specimens) && _.last(this.specimens).tissue_in_vitro_date || this.$moment().format(`YYYY/MM/DD HH:mm:ss`),
                    tissue_fixation_date: _.last(this.specimens) && _.last(this.specimens).tissue_fixation_date || this.$moment().format(`YYYY/MM/DD HH:mm:ss`)
                }
                this.specimenView.dialogFormVisible = true
            })
        },
        loadSpecimens() {
            if (!this.surgeryId) { return }
            let req = this.myaxios.get(`api/Nursing/Specimen/Specimens?surgeryInfoId=${this.surgeryId}`)
            req.then(data => {
                _.map(data, d => {
                    d.infectious = d.infectious && d.infectious.split(`,`)
                })
                console.log(123)
                console.log(data)
                this.specimens = data
                if (!this.activeSpecimenId) {
                    this.activeSpecimenId = _.last(this.specimens) && _.last(this.specimens).id
                    if (this.activeSpecimenId) {
                        this.loadTransportNode(this.activeSpecimenId)
                    }
                } else {
                    this.loadTransportNode(this.activeSpecimenId)
                }
            }).catch(e => {
                console.log(e)
                this.specimens = []
            })
        },
        loadTransportNode(id) {
            this.activeSpecimenId = id
            let req = this.myaxios.get(`/api/Nursing/Specimen/TransportNodes/${id}`)
            req.then(data => {
                this.transportNode = _.reduce(data, function(result, value, index) {
                    value.title = value.name
                    value.status = value.is_active ? `primary` : `info`
                    value.occur_time = value.occur_date
                    result.push(value)
                    if (value.sibling_node !== null) {
                        result.push({
                            title: value.sibling_node.name,
                            status: value.is_active ? `primary` : `info`,
                            occur_time: value.sibling_node.occur_date || value.occur_date
                        })
                    }
                    return result
                }, [])
            }).catch(e => {
                console.log(e)
                this.transportNode = []
            })
            // this.activeSpecimenId =id
            // let req = this.myaxios.post(`/api/Nursing/Specimen/TransportNodes/${id}`)
            // req.then(data=>{
            //     let transportNodes = [];
            //     _.reduce(data,function(result,value,key){
            //        transportNodes.push(value);
            //        if(value.sibling_node !== null){
            //            transportNodes.push(value.sibling_node);
            //        }
            //     },{})
            //     this.transportNode = transportNodes;
            // }).catch(e=>{
            //     console.log(e)
            //     this.transportNode = []
            // })
        },
        SelectedSpecimen(val, code) {
            if (val) {
                if (code && this.SpecimensSelected.findIndex(el => el == code) < 0) {
                    this.SpecimensSelected.push(code)
                }
            } else {
                this.SpecimensSelected = _.pull(this.SpecimensSelected, code)
            }
        },
        saveSpecimen(row) {
            let data = {
                'id': row.id,
                'name': row.name,
                'sampling_position': row.sampling_position,
                'quantity': row.quantity,
                'tissue_in_vitro_date': row.tissue_in_vitro_date,
                'tissue_fixation_date': row.tissue_fixation_date,
                'is_frozen_section': row.is_frozen_section || false,
                'biz_surgery_info_id': this.surgeryId,
                'application_number': row.application_number,
                'application_name': row.application_name,
                'application_date': row.application_date,
                'is_soak_section': row.is_soak_section || false,
                'soak_water': row.soak_water,
                'dic_specimentype_id': row.dic_specimentype_id,
                'infectious': row.infectious && row.infectious.join(`,`)
            }
            let req
            let tissueInVitroDate = this.$moment(row.tissue_in_vitro_date)
            let tissueFixationDate = this.$moment(row.tissue_fixation_date)
            if (this.$moment.duration(tissueInVitroDate.diff(tissueFixationDate))._milliseconds > 0) {
                this.$message.warning(`固定时间不能早于离体时间`)
                return false
            }
            if (row.id && row.id > 0) {
                req = this.myaxios.put(`/api/Nursing/Specimen/Put`, data)
            } else {
                req = this.myaxios.post(`/api/Nursing/Specimen/Post`, data)
            }

            req.then(data => {
                this.activeSpecimenId = undefined
                this.loadSpecimens()
                // this.activeSpecimenId = data.id
                this.specimenView.dialogFormVisible = false
            }).catch(e => { console.log(e) })
        },
        loadSpecimenCheckedView(specimen) {
            if (specimen.enum_specimen_status == 0) {
                this.$message.warning(`标本离体时间为空，不能送出`)
                return false
            }
            // specimen
            let row = { ...specimen }
            row.deliver_date = this.$moment().format(`YYYY/MM/DD HH:mm:ss`)
            this.specimenCheckView.data = row
            this.specimenCheckView.enum_specimen_deliver_location = specimen.is_frozen_section ? 2 : 1
            this.specimenCheckView.data.p1 = `请核对病理申请单、患者基本信息如姓名${this.T(`specimen.visit_no`)}、标本袋标签完整性等`
            this.specimenCheckView.dialogFormVisible = true
        },
        specimenChecked(specimen) { // 标本核对并转出
            let req = this.myaxios.put(`/api/Nursing/Specimen/Deliver`, {
                id: specimen.id,
                deliverer: specimen.deliverer,
                deliver_date: specimen.deliver_date,
                enum_specimen_deliver_location: specimen.enum_specimen_deliver_location, // 2病理科  1标本间
                identification_code: specimen.identification_code,
                application_number: specimen.application_number,
                biz_surgery_info_id: specimen.biz_surgery_info_id,
                dic_specimentype_id: specimen.dic_specimentype_id
            })
            req.then(data => {
                this.loadSpecimens()
                this.specimenCheckView.dialogFormVisible = false
            }).catch(e => console.log(e))
        },
        deleteSpecimen(specimen) {
            let that = this
            this.$confirm(`此操作将永久删除该记录, 是否继续?`, `提示`, {
                confirmButtonText: `确定`,
                cancelButtonText: `取消`,
                type: `warning`,
                closeOnClickModal: false
            }).then(() => {
                let req = that.myaxios.delete(`/api/Nursing/Specimen/Delete/${specimen.id}`)
                req.then(data => {
                    this.activeSpecimenId = undefined
                    that.loadSpecimens()
                }).catch(e => { console.log(e) })
            })
        },
        loadUpdateView(specimen) {
            this.specimenView.title = `编辑`
            this.specimenView.data = { ...specimen }
            this.specimenView.dialogFormVisible = true
        },
        scanCode() {
            let spec = _.find(this.specimens, { identification_code: this.scan_val })
            console.log(spec)
            if (!spec) {
                this.loadAddSpecimenView(this.scan_val)
            } else if (spec.enum_specimen_status == 0) {
                this.loadUpdateView(spec)
            } else if (spec.enum_specimen_status == 1) {
                this.loadSpecimenCheckedView(spec)
            }
        },
        printbar(specimen) {
            let req = this.myaxios.get(`/api/AcisSystem/SystemServer/CreateBarcode?code=${specimen.identification_code}&category=标本`)
            req.then(data => {
                this.primary_item = {
                    bar_code: `data:image/jpeg;base64,` + data,
                    patient_name: specimen.surgery_info.patient_name,
                    sex: specimen.surgery_info.sex,
                    age: specimen.surgery_info.age,
                    visit_no: specimen.surgery_info.visit_no,
                    dic_section: specimen.surgery_info.dic_section,
                    name: specimen.name,
                    bed_no: specimen.surgery_info.bed_no,
                    quantity: specimen.quantity,
                    identification_code: specimen.identification_code,
                    application_number: specimen.application_number,
                    tissue_in_vitro_date: specimen.tissue_in_vitro_date && this.$moment(specimen.tissue_in_vitro_date).format(`YYYY 年 MM 月 DD 日 HH 时 mm 分`),
                    deliver_date: specimen.deliver_date && this.$moment(specimen.deliver_date).format(`YYYY 年 MM 月 DD 日`)
                }
                this.$nextTick(() => {
                    setTimeout(() => {
                        const style = `
                        @page {margin:0 10mm};
                        @media print{
                            td {background:red;};
                            .td_place{
                                display: inline;border-bottom: 1px solid;width: 140px;position: absolute;bottom: 0;
                            }
                        }`
                        printJs({ printable: `print-content`, type: `html`, base64: true, maxWidth: 1500, style, targetStyles: [`*`] })
                    }, 500)
                })
            })
        },
        printBatchBar() {
            // 批量打印条形码
            if (this.SpecimensSelected.length <= 0) {
                this.$message.warning(`未选择打印标本`)
                return
            }
            var codes = this.SpecimensSelected.map(d => d).toString()
            this.printBarByCode(codes)
        },
        syncSpecimenApplication() {
            let req = this.myaxios.post(`/api/Nursing/Specimen/SyncApplication`, {
                biz_surgery_info_id: this.surgeryId
            })
            req.then(data => {
                console.log(data)
                if (data) {
                    this.$message.info(data.msg)
                }
            }).catch(e => console.log(e))
        },
        printOneBar(row) {
            // 打印单个条形码
            var code = row.identification_code
            this.printBarByCode(code)
        },
        printBarByCode(code) {
            // 调用文书根据code打印条形码,多个逗号隔开
            if (!code) {
                this.$message.warning(`未选择打印标本`)
                return
            }
            // 调用生成条形码图片
            let req = this.myaxios.get(`/api/AcisSystem/SystemServer/CreateBarcodesImg?codes=${code}&category=标本`)
            console.log(this.$root.DOCUMENT[`BLBB002`])
            req.then(data => {
                this.$store.dispatch(`PRINT_PDF`, {
                    host: this.$root.DOCSERVICE_BASE,
                    params: Object.assign(
                        {
                            docid: this.$root.DOCUMENT.BLBB002,
                            id1: `999999`,
                            objId: code
                        },
                        { isShowSendPrintMessage: this.$root.isShowSendPrintMessage }
                    )
                })
            }).catch(e => {
                console.log(e)
            })
        },
        printDocument(row) {
            // 打印送检单
            if (row.id) {
                let req2 = this.myaxios.get(`/api/AcisSystem/Config/GetByKey?key=isShowSendPrintMessage`)
                console.log(this.$root.DOCUMENT[row.doccode])
                req2.then(isShow => {
                    this.$store.dispatch(`PRINT_PDF`, {
                        host: this.$root.DOCSERVICE_BASE,
                        params: Object.assign(
                            {
                                docid: this.$root.DOCUMENT[row.doccode], // this.$root.DOCUMENT.BLBB001,
                                id1: `999999`,
                                objId: row.id
                            },
                            { isShowSendPrintMessage: isShow.value }
                        )
                    })
                }).catch(e => {
                    console.log(e)
                })
            }
        },
        loadSpecimenTypes() {
            let req = this.myaxios.get(`/api/AcisSystem/SpecimenType/Get`)
            req.then(data => {
                this.SpecimenTypes = _.map(data, d => {
                    return {
                        label: d.name,
                        value: d.id,
                        disabled: d.is_deleted
                    }
                })
            })
        }
    },
    watch: {
        $route: function(newUrl, oldUrl) {
            this.surgeryId = newUrl.query.surgery_id
            this.transportNode = []
            this.activeSpecimenId = undefined
            this.loadSpecimens()
        },
        'specimenTmp.selected_template': function(newval, oldval) {
            // 加载已选模板详情
            if (!newval) return
            let that = this
            let req = that.myaxios.get(`/api/Nursing/SpecimenTemplate/Get/${newval}`)
            req.then(template => {
                that.specimenTmp.datalist = template.details && _.map(template.details, d => {
                    d.tissue_in_vitro_date = this.$moment().format(`YYYY/MM/DD HH:mm:ss`)
                    return d
                })
            })
        }
    }
}
</script>
<style scoped lang="less">
.no-surgery {
    line-height: 600px;
    font-size: 24px;
    opacity: 0.5;
}
.specimen:hover {
    box-shadow: 10px 10px 10px rgba(0, 0, 0, 0.4);
    //outline: solid darkgray 2px;
}
.specimen {
    &.active {
        background: darkgray;
        box-shadow: 10px 10px 10px rgba(0, 0, 0, 0.4);
    }
    background: gainsboro;
    height: 320px;
    cursor: pointer;
    .content {
        background: whitesmoke;
        height: 210px;
        overflow: hidden;
        line-height: 1.5em;
    }
}
.specimen-new {
    display: flex;
    align-items: center;
    justify-content: center;
    outline: dashed 0.5px;
    color: darkgray;
    font-size: 24px;
    background: inherit;
    &:hover {
        color: gray;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Surgery/Specimen/Index.vue